import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './styles.css';

class Header extends Component {
	render() {
		const { children } = this.props;
		return (
			<div className="main-layout-header">
				{children.map((child, index) => 
					<div key={index} className="main-layout-header-block">
						{child}
					</div>
				)}
			</div>
		);
	}
}
Header.propTypes = {
	children: PropTypes.node
};

export default Header;
